export const FeedAssetsBucketPrefix = `https://${process.env.REACT_APP_DOMAIN}-climate-investment-feed-media.s3-us-west-2.amazonaws.com/`;

